import get from 'lodash/get';
import includes from 'lodash/includes';

import { graphQLCacheClient } from '../../graphQLClients';

import { CreateItemGqlQuery } from '../../../../../types';

import { generateUuid } from '../../../../../utils/generateUuid';
import { getQueryName } from '../../../../../utils/getQueryName';
import { productionConsole } from '../../../../../utils/productionConsole';

import { errorMessageStatusOrErrorsIsIncorrect } from '../../reactQueryConstants';

interface CreateCacheItemProps<CreateCacheItemInput> {
  action: string;
  query: CreateItemGqlQuery;
  queryInput: CreateCacheItemInput;
}

const successQueryStatuses = ['created', 'success'];

export function createCacheItem<CreateCacheItemInput, CreateCacheItemResponse>({
  action,
  query,
  queryInput
}: CreateCacheItemProps<CreateCacheItemInput>) {
  const { rawName, name } = getQueryName(query, 'mutation');

  productionConsole(
    'log',
    'createCacheItem',
    { action, queryInput },
    rawName,
    JSON.stringify(queryInput)
  );

  const requestId = generateUuid();

  graphQLCacheClient.addQueryParams(name, requestId);

  return new Promise<CreateCacheItemResponse>((resolve, reject) => {
    graphQLCacheClient
      .request<CreateCacheItemResponse, CreateCacheItemInput>(
        query,
        queryInput,
        {
          requestId
        }
      )
      .then((response) => {
        if (includes(successQueryStatuses, get(response, `${action}.status`))) {
          return resolve(response);
        }

        const errors = get(response, `${action}.errors`);

        reject(errors ? errors : errorMessageStatusOrErrorsIsIncorrect);
      })
      .catch((reason) => reject(reason));
  });
}
